module.exports = __webpack_public_path__ + "img/indoor4.98fa471f.jpg";